<template>
  <v-expansion-panel>
    <v-expansion-panel-header>Disponibilidade - Semanal</v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-expansion-panels
        :value="expansionPanelQueDeveAbrirPorDefault"
        focusable
      >
        <v-row>
          <v-col
            v-for="(dia, index) in disponibilidadesLocale"
            :key="index"
            md="6"
            cols="12"
          >
            <agenda-disponibilidade-dia-semana
              :dia-semana-id="dia.diaSemanaId"
              :titulo="dia.titulo"
              :disponibilidades-do-dia="dia.valores"
              :agente-id="agenteId"
              :pode-editar="podeEditar"
              @refetch-data="$emit('refetch-data')"
            />
          </v-col>
        </v-row>
      </v-expansion-panels>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import AgendaDisponibilidadeDiaSemana from './AgendaDisponibilidadeDiaSemana.vue'
import DiasSemanaEnum from '@/models/entities/agente/DiasSemanaEnum'

export default {
  emits: ['refetch-data'],

  components: {
    AgendaDisponibilidadeDiaSemana,
  },

  props: {
    disponibilidadesDoAgente: {
      type: Array,
      required: true,
    },
    // NOVAS PROPS OBRIGATÓRIAS
    agenteId: {
      type: Number,
      required: true,
    },
    podeEditar: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const expansionPanelQueDeveAbrirPorDefault = ref(0)
    const disponibilidadesLocale = ref([
      { diaSemanaId: DiasSemanaEnum.Segunda, titulo: 'Segunda', valores: [] },
      { diaSemanaId: DiasSemanaEnum.Terca, titulo: 'Terça', valores: [] },
      { diaSemanaId: DiasSemanaEnum.Quarta, titulo: 'Quarta', valores: [] },
      { diaSemanaId: DiasSemanaEnum.Quinta, titulo: 'Quinta', valores: [] },
      { diaSemanaId: DiasSemanaEnum.Sexta, titulo: 'Sexta', valores: [] },
      { diaSemanaId: DiasSemanaEnum.Sabado, titulo: 'Sábado', valores: [] },
      { diaSemanaId: DiasSemanaEnum.Domingo, titulo: 'Domingo', valores: [] },
    ])

    function resetDisponibilidades() {
      for (let i = 0; i < disponibilidadesLocale.value.length; i++) {
        disponibilidadesLocale.value[i].valores = []
      }
    }

    function parseDisponibilidadesFromApi(disponibilidadesApi, diaSemanaId) {
      return disponibilidadesApi
        .filter(it => it.diaSemana === diaSemanaId)
        .map(it => ({
          id: it.id,
          inicial: it.horaInicial,
          final: it.horaFinal,
          periodoDiaDisponibilidadeId: it.periodoDiaDisponibilidadeId,
          periodoDiaDisponibilidadeNome: it.periodoDiaDisponibilidadeNome,
        }))
    }

    watch(
      () => props.disponibilidadesDoAgente,
      v => {
        if (!v.length) {
          resetDisponibilidades()
          return
        }

        disponibilidadesLocale.value[0].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Segunda)
        disponibilidadesLocale.value[1].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Terca)
        disponibilidadesLocale.value[2].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Quarta)
        disponibilidadesLocale.value[3].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Quinta)
        disponibilidadesLocale.value[4].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Sexta)
        disponibilidadesLocale.value[5].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Sabado)
        disponibilidadesLocale.value[6].valores = parseDisponibilidadesFromApi(v, DiasSemanaEnum.Domingo)
      },
      {
        immediate: true,
        deep: true,
      },
    )

    return {
      expansionPanelQueDeveAbrirPorDefault,
      disponibilidadesLocale,
    }
  },
}
</script>
